<template>
  <div 
    class="dt-tab--container"
    ref="tabContainer"  
  >
    <div 
      class="dt-tab--bar"
      v-if="showTabBar"  
    >
      <slot 
        v-bind="tabs"
        name="dt-tab--bar"
      >
        <div 
          class="dt-tab--bar__item"
          v-for="tab of tabs"  
          :key="tab.value"
          :style="{
            'max-width': tabBarItemWidth+'px'
          }"
        >
          {{tab.text}}
        </div>
      </slot>
    </div>
    {{tabContainerWidth}}
    {{tabContainerWidthPx}}
    <div 
      class="dt-tab--list"
      :style="{
        'width': tabContainerWidthPx
      }"
    >
      <div 
        v-for="tab of tabs"
        :key="tab.value"  

        class="dt-tab--item"
      >
        <slot
          :name="tab.value"
        ></slot>
      </div>
    </div>
  </div>
</template>

<script>

const TAB_MARGIN_L = 0;


export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    showTabBar: {
      type: Boolean,
      default: true
    },
    tabBarItemWidth: {
      type: Number,
      default: 200,
    },
    active: {
      type: String
    }
  },
  watch: {
    active: {
      immediate: true,
      handler: function(newVal, oldVal) {

      }
    }
  },
  data: function() {
    return {
      tabContainerWidth: 0,
    }
  },
  mounted: function() {
    console.log(this.$refs['tabContainer']);
    
    setTimeout(() => {
      const tabContainerRect = this.$refs['tabContainer'].getBoundingClientRect();
      console.log(this.$refs['tabContainer'], tabContainerRect);
      this.tabContainerWidth = tabContainerRect.width;
    }, 1000);
  },
  computed: {
    tabContainerWidthPx: function() {
      return `${this.tabs.length * (this.tabContainerWidth + TAB_MARGIN_L)}px`;
    }
  }
}
</script>

<style lang="scss" scoped>

.dt-tab--container {
  // height: 100%;
  // width: 100%;

  overflow: hidden;
}

.dt-tab--bar {
  display: flex;
  .dt-tab--bar__item {
    flex: 1;
    cursor: pointer;
    background: lightcyan;
  }
}

.dt-tab--list {
  display: flex;
  position: relative;

  height: 100%;

  .dt-tab--item {
    flex: 1;
    width: 100%;
  }
}

</style>
